<div
  edsPadding
  [edsPaddingRight]="(isHandheld$ | async) ? 'md' : 'xxl'"
  [edsPaddingLeft]="(isHandheld$ | async) ? 'md' : 'xxl'"
>
  <div>
    <eds-proximal
      edsSpacing="lg"
      [placement]="'CapitalGainsTop'"
    ></eds-proximal>
    <p class="small" #scroll>
      <b>{{ todaysDateLabel }}</b>
    </p>
  </div>

  <section *ngIf="filteredGridListing?.length; else gridListingEmpty">
    <div>
      <eds-accordion class="us-capital-gains-listing">
        <button
          (click)="toggleExpanded()"
          edsButton="icon-only"
          size="normal"
          edsSpacing="md"
        >
          <eds-icon
            [type]="expand ? 'carrot-up' : 'carrot-down'"
            size="small"
          ></eds-icon>
          <span edsPadding edsPaddingLeft="sm">
            {{
              expand
                ? ("products.collapse-all" | translate)
                : ("products.expand-all" | translate)
            }}
          </span>
        </button>
        <eds-accordion-item
          *ngFor="let gridListObj of filteredGridListing"
          [title]="getAccordianTitle('primary', gridListObj)"
          [secondaryTitle]="getAccordianTitle('secondary', gridListObj)"
          edsSpacing="none"
          [expanded]="expand"
        >
          <!-- View when fund has no distributions i.e., no table -->
          <div *ngIf="gridListObj.hasNoDistributions">
            <table class="table">
              <tbody class="table__body">
                <tr class="table__tr">
                  <td
                    class="table__td text-align-left"
                    edsFlexbox
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <div edsFlexbox alignItems="center">
                      <eds-icon type="info" size="small" edsTooltip></eds-icon>
                      &nbsp;
                      <b>
                        {{
                          "products.capgains-no-distribution-data-message"
                            | translate
                        }}
                      </b>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                    </div>

                    <eds-link-item
                      *ngIf="gridListObj.fundStatus !== 'soft-launch'"
                      [title]="'products.capgains-fund-details' | translate"
                      [href]="gridListObj.fundLink"
                    ></eds-link-item>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- View when fund has distributions i.e., expected table -->
          <div *ngIf="!gridListObj.hasNoDistributions">
            <table class="table" *ngIf="(isHandheld$ | async) === false">
              <thead class="table__thead">
                <tr class="table__tr">
                  <th class="table__th text-align-left">
                    <span class="small">{{
                      "pds.INCM_DIST_RECORD_DATE"
                        | translate: gridListObj.fundId
                    }}</span>
                  </th>
                  <th class="table__th text-align-left">
                    <span class="small">{{
                      "pds.INCM_DIST_EX_DIV_DATE"
                        | translate: gridListObj.fundId
                    }}</span>
                  </th>
                  <th class="table__th text-align-left">
                    <span class="small">{{
                      "pds.INCM_DIST_PAYABLE_DATE"
                        | translate: gridListObj.fundId
                    }}</span>
                  </th>
                  <th class="table__th text-align-right">
                    <span class="small">{{
                      "pds.REINVESTMENT_AMT" | translate: gridListObj.fundId
                    }}</span>
                  </th>
                  <th class="table__th text-align-right">
                    <span class="small">{{
                      "pds.CAPGAIN_AMT_LONG_TERM"
                        | translate: gridListObj.fundId
                    }}</span>
                  </th>
                  <th class="table__th text-align-right">
                    <span class="small">{{
                      "pds.CAPGAIN_AMT_SHRT_TERM"
                        | translate: gridListObj.fundId
                    }}</span>
                  </th>
                  <th class="table__th text-align-right">
                    <span class="small">{{
                      "pds.TOTAL_CAP_GAINS" | translate: gridListObj.fundId
                    }}</span>
                  </th>
                  <th
                    *ngIf="gridListObj.fundStatus !== 'soft-launch'"
                    class="table__th text-align-left"
                  >
                    <span class="small">{{
                      "products.capgains-actions"
                        | translate: gridListObj.fundId
                    }}</span>
                  </th>
                </tr>
              </thead>
              <tbody class="table__body">
                <tr
                  class="table__tr"
                  *ngFor="let tableRow of gridListObj.tableDetails"
                >
                  <td class="table__td text-align-left">
                    {{
                      tableRow.capitalGainRecordDate
                        ? tableRow.capitalGainRecordDate
                        : placeholderHyphens
                    }}
                  </td>
                  <td class="table__td text-align-left">
                    {{
                      tableRow.capitalGainExDividendDate
                        ? tableRow.capitalGainExDividendDate
                        : placeholderHyphens
                    }}
                  </td>
                  <td class="table__td text-align-left">
                    {{
                      tableRow.capitalGainPayableDate
                        ? tableRow.capitalGainPayableDate
                        : placeholderHyphens
                    }}
                  </td>
                  <td
                    class="table__td"
                    [ngClass]="[
                      tableRow.capitalGainReInvestmentAmount
                        ? 'text-align-right'
                        : 'text-align-left'
                    ]"
                  >
                    {{
                      tableRow.capitalGainReInvestmentAmount
                        ? tableRow.capitalGainReInvestmentAmount
                        : placeholderHyphens
                    }}
                  </td>
                  <td
                    *ngIf="tableRow.estimateFlag"
                    class="table__td text-align-right table__td--loss"
                  >
                    {{ tableRow.longTermCapitalGainAmount }}
                    {{ "products.capgains-est" | translate }}
                  </td>
                  <td
                    *ngIf="!tableRow.estimateFlag"
                    class="table__td"
                    [ngClass]="[
                      tableRow.longTermCapitalGainAmount
                        ? 'text-align-right'
                        : 'text-align-left'
                    ]"
                  >
                    {{
                      tableRow.longTermCapitalGainAmount
                        ? tableRow.longTermCapitalGainAmount
                        : placeholderHyphens
                    }}
                  </td>
                  <td
                    *ngIf="tableRow.estimateFlag"
                    class="table__td text-align-right table__td--loss"
                  >
                    {{ tableRow.shortTermCapitalGainAmount }}
                    {{ "products.capgains-est" | translate }}
                  </td>
                  <td
                    *ngIf="!tableRow.estimateFlag"
                    class="table__td"
                    [ngClass]="[
                      tableRow.shortTermCapitalGainAmount
                        ? 'text-align-right'
                        : 'text-align-left'
                    ]"
                  >
                    {{
                      tableRow.shortTermCapitalGainAmount
                        ? tableRow.shortTermCapitalGainAmount
                        : placeholderHyphens
                    }}
                  </td>
                  <td
                    *ngIf="tableRow.estimateFlag"
                    class="table__td text-align-right table__td--loss"
                  >
                    {{ tableRow.totalDistributionAmountMonthly }}
                    {{ "products.capgains-est" | translate }}
                  </td>
                  <td
                    *ngIf="!tableRow.estimateFlag"
                    class="table__td"
                    [ngClass]="[
                      tableRow.totalDistributionAmountMonthly
                        ? 'text-align-right'
                        : 'text-align-left'
                    ]"
                  >
                    {{
                      tableRow.totalDistributionAmountMonthly
                        ? tableRow.totalDistributionAmountMonthly
                        : placeholderHyphens
                    }}
                  </td>
                  <td
                    *ngIf="gridListObj.fundStatus !== 'soft-launch'"
                    class="table__td text-align-left"
                  >
                    <eds-link-item
                      [title]="'products.capgains-fund-details' | translate"
                      [href]="gridListObj.fundLink"
                    ></eds-link-item>
                  </td>
                </tr>
              </tbody>
            </table>

            <ng-container *ngIf="isHandheld$ | async">
              <ng-container
                *ngFor="let card of gridListObj?.cards; even as isevenrow"
              >
                <eds-panel
                  edsSpacing="xs"
                  [hasBorders]="false"
                  [hasBorderRadius]="false"
                  [hasPadding]="true"
                  [theme]="isevenrow ? 'grey' : 'basic'"
                >
                  <eds-info-item
                    *ngFor="let item of card"
                    [info]="item"
                    edsSpacing="sm"
                  >
                  </eds-info-item>
                </eds-panel>
              </ng-container>
              <eds-panel
                [hasBorders]="false"
                [hasBorderRadius]="false"
                [hasPadding]="true"
              >
                <eds-link-item
                  [title]="'products.capgains-fund-details' | translate"
                  [href]="gridListObj.fundLink"
                ></eds-link-item>
              </eds-panel>
            </ng-container>
          </div>
        </eds-accordion-item>
      </eds-accordion>

      <!-- tablet and mobile view -->
      <!-- <ng-template #cardViewBlock>
        <div *ngFor="let info of data; let i = index">
          <eds-panel *ngIf="i % 2 == 0" edsSpacing="md" [hasPadding]="true">
            <eds-info-item *ngFor="let infoItem of info" [info]="infoItem">
            </eds-info-item>
          </eds-panel>
          <eds-panel
            *ngIf="i % 2 != 0"
            edsSpacing="md"
            theme="grey"
            [hasPadding]="true"
          >
            <eds-info-item *ngFor="let infoItem of info" [info]="infoItem">
            </eds-info-item>
          </eds-panel>
        </div>
      </ng-template> -->
    </div>

    <div
      *ngIf="totalPages > 0"
      edsFlexbox
      [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
      [alignItems]="(isHandheld$ | async) ? '' : 'center'"
      justifyContent="space-between"
      edsPadding
      edsPaddingTop="lg"
      edsPaddingBottom="xxl"
    >
      <eds-pagination
        edsFlexItem
        [alignSelf]="(isHandheld$ | async) ? 'flex-end' : ''"
        [edsSpacing]="(isHandheld$ | async) ? 'xl' : ''"
        [pages]="totalPages"
        [pageTitle]="pageTitle"
        (pageChanged)="onPageChanged($event)"
        [prevPageText]="'products.previous' | translate"
        [nextPageText]="'products.next' | translate"
        [ariaLabelGoToPage]="'products?.ariaLabelGoToPage' | translate"
      ></eds-pagination>

      <eds-dropdown
        ariaLabel="Dropdown"
        [dropdownId]="'ItemsPerPageBottomDD'"
        name="BottomDropDown"
        [items]="pageSizeBottomOptions"
        [label]="'products.items-per-page' | translate"
        [preselectedValue]="selectedPageSizeOption"
        titleText="10"
        edsPadding
        edsPaddingLeft="none"
        (dropdownChange)="onDropdownChange($event)"
      ></eds-dropdown>
    </div>
  </section>

  <ng-template #gridListingEmpty>
    <p *ngIf="isFilterProcessing" class="bold large">
      {{ "products.capgains-no-filter-result-message" | translate }}
    </p>
  </ng-template>
</div>
